import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';

let mdDialogHolder: MatDialog;

export function SetMdDialog(dialog: MatDialog) {
  mdDialogHolder = dialog;
}

export async function OpenDialog(component, params = {}, config?) {
  return mdDialogHolder
    .open(
      component,
      Object.assign(
        {
          data: params,
          panelClass: 'bd-dialog-panel',
        },
        config
      )
    )
    .afterClosed()
    .toPromise()
    .then((result) => {
      const { status, data } = result || { status: 'cancel', data: {} };
      return new Promise<any>((resolve, reject) => {
        if (status === 'cancel') {
          return reject(data);
        }
        return resolve(data);
      });
    });
}

export async function ConfirmDialog(content, title?, okText = 'Ok', cancelText = 'Cancel') {
  return OpenDialog(ConfirmDialogComponent, {
    title,
    content,
    okText,
    cancelText,
  });
}

export function AlertDialog(content, title?, okText = 'Ok') {
  return OpenDialog(AlertDialogComponent, {
    title,
    content,
    okText,
  });
}
